// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar_root__1EeiY","image":"Avatar_image__2zuWG"};